import {FuncaoOriginalSalaModel} from '@/models/gestao/funcaooriginalsala/funcaooriginalsala.model'
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class FuncaoOriginalSalaService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<FuncaoOriginalSalaModel>>> {
  return api.post <DataSource <FuncaoOriginalSalaModel>>('/FuncaoOriginalSala/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(funcaoOriginalSala: FuncaoOriginalSalaModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/FuncaoOriginalSala', funcaoOriginalSala);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/FuncaoOriginalSala/' + id);
 }

 atualizar(funcaoOriginalSala: FuncaoOriginalSalaModel): Promise<AxiosResponse> {
  return api.put('/FuncaoOriginalSala', funcaoOriginalSala);
 }

 async get(id: number): Promise<FuncaoOriginalSalaModel> {
  const result = await api.get<FuncaoOriginalSalaModel>(`/FuncaoOriginalSala/${id.toString()}`);
  return result.data;
 }

 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/FuncaoOriginalSala/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new FuncaoOriginalSalaService();
